/* SigueArmando · "Enciende tu patio" v3: encendido real entre dos fotografías + linterna + armador de combos (sin librerías) */
(function () {
  var root = document.querySelector('[data-sa-patio]');
  if (!root) return;
  var dataEl = root.querySelector('[data-sa-data]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = function (s, r) { return (r || root).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var clamp = function (x, a, b) { return Math.max(a, Math.min(b, x)); };
  var smooth = function (a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------- datos ---------- */
  var SHORT = {
    pack3: 'Pack 3 focos con control', pack3cam: 'Pack 3 focos tipo cámara', foco100: 'Foco 100 LED con sensor',
    focoCalido: 'Foco luz cálida (2 ampolletas)', g10: 'Guirnalda solar 10 m', g20: 'Guirnalda solar 20 m',
    navidad: 'Luces de Navidad 20 m', cam: 'Cámara wifi 360°'
  };
  var GROUPS = [
    { name: 'Focos', keys: ['pack3', 'pack3cam', 'foco100', 'focoCalido'] },
    { name: 'Guirnaldas y Navidad', keys: ['g10', 'g20', 'navidad'] },
    { name: 'Seguridad', keys: ['cam'] }
  ];
  /* qué zonas de la foto "encendida" se revelan con cada producto */
  var FX = {
    pack3: ['wallBig', 'wallMid', 'wallSmall'],
    pack3cam: ['fence', 'fenceL'],
    foco100: ['plantsR', 'table'],
    focoCalido: ['treeBase', 'plantBig'],
    g10: ['line1'],
    g20: ['line1', 'line2'],
    navidad: ['xmas'],
    cam: ['camGlow']
  };
  var MARK = {
    pack3: [87, 21, 'Pack 3 focos'],
    pack3cam: [30, 50, 'Focos tipo cámara'],
    foco100: [78, 70, 'Foco 100 LED'],
    focoCalido: [20, 58, 'Luz cálida'],
    g10: [30, 17, 'Guirnalda 10 m'],
    g20: [46, 24, 'Guirnalda 20 m'],
    navidad: [19, 35, 'Luces de Navidad'],
    cam: [72.7, 27.3, 'Cámara 360°']
  };
  /* zonas (porcentajes de la foto). pts = [x, y, radio] ; ell = [x, y, rx, ry] ; glow: color de bloom ; only: solo resplandor */
  var ZONES = {
    line1: { warm: 1, pts: [[1.5, 11.3, 7], [12.7, 13.8, 7], [22.4, 15.6, 7], [30.7, 16.7, 7], [38.2, 17.3, 7], [44.4, 17.6, 7], [49.8, 17.8, 7], [55.1, 17.6, 7], [59.6, 17.5, 7], [64.5, 18.2, 7], [68.7, 16.7, 7]] },
    line2: { warm: 1, pts: [[6.9, 29.6, 7], [13.6, 29.1, 7], [20.9, 28.2, 7], [28.5, 27.3, 7], [35.8, 25.8, 7], [43.3, 24.2, 7], [50.7, 22.7, 7], [57.8, 20.9, 7]] },
    wallBig: { ell: [[89, 28, 22, 28], [87.3, 20.9, 9, 9]] },
    wallMid: { ell: [[72, 42, 17, 24], [68.7, 32.4, 8, 8]] },
    wallSmall: { ell: [[58, 48, 14, 20], [55.5, 37.8, 7, 7]] },
    plantsR: { warm: 1, ell: [[78, 73, 18, 15]] },
    fence: { warm: 1, ell: [[30, 50, 26, 12]] },
    fenceL: { warm: 1, ell: [[8, 52, 12, 10]] },
    table: { warm: 1, ell: [[30, 67, 18, 12]] },
    treeBase: { warm: 1, ell: [[20, 46, 18, 28]] },
    plantBig: { warm: 1, ell: [[52.7, 58, 12, 16]] },
    camGlow: { only: 1, rgb: '150,205,255', ell: [[72.7, 30, 9, 9], [60, 80, 20, 9]] }
  };
  var P = {};
  data.products.forEach(function (p) { if (p.available) P[p.key] = p; });
  var combos = data.combos.filter(function (c) {
    return c.available && c.needs.every(function (k) { return P[k]; });
  });
  var sel = {};
  var night = 0;

  /* ---------- escena: dos fotografías reales ---------- */
  var photo = q('[data-photo]');
  var srcOn = photo.getAttribute('data-src-on'), srcOff = photo.getAttribute('data-src-off');
  var base = document.createElement('div');
  base.className = 'sa-photo__base';
  base.style.backgroundImage = 'url("' + srcOff + '")';
  photo.appendChild(base);
  var dusk = document.createElement('div'); dusk.className = 'sa-photo__dusk'; photo.appendChild(dusk);

  function maskFor(z) {
    var m = [];
    (z.pts || []).forEach(function (p) {
      m.push('radial-gradient(ellipse ' + p[2] + '% ' + p[2] + '% at ' + p[0] + '% ' + p[1] + '%, #000 25%, transparent 100%)');
    });
    (z.ell || []).forEach(function (e) {
      m.push('radial-gradient(ellipse ' + e[2] + '% ' + e[3] + '% at ' + e[0] + '% ' + e[1] + '%, #000 35%, transparent 100%)');
    });
    return m.join(',');
  }
  function glowFor(z) {
    var rgb = z.rgb || (z.warm ? '255,190,110' : '255,238,205');
    var g = [];
    (z.pts || []).forEach(function (p) {
      g.push('radial-gradient(ellipse ' + (p[2] * 1.5) + '% ' + (p[2] * 1.5) + '% at ' + p[0] + '% ' + p[1] + '%, rgba(' + rgb + ',.5) 0%, rgba(' + rgb + ',0) 100%)');
    });
    (z.ell || []).forEach(function (e) {
      g.push('radial-gradient(ellipse ' + e[2] + '% ' + e[3] + '% at ' + e[0] + '% ' + e[1] + '%, rgba(' + rgb + ',' + (z.only ? '.4' : '.22') + ') 0%, rgba(' + rgb + ',0) 100%)');
    });
    return g.join(',');
  }
  var layers = {};
  Object.keys(ZONES).forEach(function (name) {
    var z = ZONES[name];
    var wrap = document.createElement('div');
    wrap.className = 'sa-zone'; wrap.dataset.zone = name;
    var m = maskFor(z);
    if (!z.only) {
      var lit = document.createElement('div'); lit.className = 'sa-zone__lit';
      lit.style.backgroundImage = 'url("' + srcOn + '")';
      lit.style.webkitMaskImage = m; lit.style.maskImage = m;
      var bloom = document.createElement('div'); bloom.className = 'sa-zone__bloom';
      bloom.style.backgroundImage = 'url("' + srcOn + '")';
      bloom.style.webkitMaskImage = m; bloom.style.maskImage = m;
      wrap.appendChild(lit); wrap.appendChild(bloom);
    }
    var glow = document.createElement('div'); glow.className = 'sa-zone__glow';
    glow.style.backgroundImage = glowFor(z);
    wrap.appendChild(glow);
    photo.appendChild(wrap);
    layers[name] = wrap;
  });

  /* luces de Navidad: puntos de color suaves sobre el árbol */
  var xmas = document.createElement('div'); xmas.className = 'sa-zone sa-xmas'; xmas.dataset.zone = 'xmas';
  var COL = ['#FF6B6B', '#FFD166', '#4ECDC4', '#74B9FF', '#F78FB3', '#FFB142'];
  var seed = 11; function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  for (var i = 0; i < 22; i++) {
    var a = rnd() * Math.PI * 2, r = Math.sqrt(rnd());
    var dot = document.createElement('i');
    dot.style.left = (19 + Math.cos(a) * r * 10.5).toFixed(1) + '%';
    dot.style.top = (35 + Math.sin(a) * r * 11).toFixed(1) + '%';
    dot.style.setProperty('--c', COL[i % 6]);
    dot.style.setProperty('--d', (i * 60) + 'ms');
    xmas.appendChild(dot);
  }
  photo.appendChild(xmas); layers.xmas = xmas;

  /* linterna: la luz sigue al puntero y revela la foto encendida */
  var torch = document.createElement('div'); torch.className = 'sa-torch';
  var torchLit = document.createElement('div'); torchLit.className = 'sa-torch__lit';
  torchLit.style.backgroundImage = 'url("' + srcOn + '")';
  torch.appendChild(torchLit); photo.appendChild(torch);
  var fxTop = document.createElement('div'); fxTop.className = 'sa-photo__fx'; photo.appendChild(fxTop);
  var stage = photo.parentNode;
  stage.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch') return;
    var r = photo.getBoundingClientRect();
    photo.style.setProperty('--tx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
    photo.style.setProperty('--ty', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    torch.classList.add('on');
  });
  stage.addEventListener('pointerleave', function () { torch.classList.remove('on'); });

  /* etiquetas discretas */
  var marks = {};
  Object.keys(MARK).forEach(function (k) {
    var m = MARK[k], el = document.createElement('div');
    el.className = 'sa-mark' + (m[0] > 72 ? ' sa-mark--left' : '');
    el.style.left = m[0] + '%'; el.style.top = m[1] + '%';
    el.innerHTML = '<i></i><b>' + m[2] + '</b>';
    photo.appendChild(el); marks[k] = { el: el, t: 0 };
  });
  function showMark(k) {
    var mk = marks[k]; if (!mk) return;
    clearTimeout(mk.t);
    mk.el.classList.remove('show'); void mk.el.offsetWidth;
    mk.el.classList.add('show');
    mk.t = setTimeout(function () { mk.el.classList.remove('show'); }, 2600);
  }
  function hideMark(k) { var mk = marks[k]; if (mk) { clearTimeout(mk.t); mk.el.classList.remove('show'); } }

  function paint() {
    var n = night, s = smooth(0, 1, n);
    var b = lerp(1.55, 0.52, s);
    base.style.filter = 'brightness(' + b.toFixed(3) + ') saturate(' + lerp(1.15, 0.92, s).toFixed(2) + ') contrast(' + lerp(0.92, 1.05, s).toFixed(2) + ')';
    dusk.style.opacity = (0.95 * (1 - smooth(0, 0.7, n))).toFixed(2);
    photo.style.setProperty('--L', smooth(0.22, 0.72, n).toFixed(3));
  }
  function setNight(v, fromSlider) {
    night = clamp(v, 0, 1);
    paint();
    if (fromSlider !== true) slider.value = Math.round(night * 100);
  }

  function applyScene() {
    var on = {};
    Object.keys(sel).forEach(function (k) { (FX[k] || []).forEach(function (z) { on[z] = 1; }); });
    Object.keys(layers).forEach(function (z) { layers[z].classList.toggle('on', !!on[z]); });
    var count = Object.keys(sel).length;
    photo.setAttribute('aria-label', count
      ? 'Patio de noche con ' + count + ' producto' + (count > 1 ? 's' : '') + ' de iluminación instalados'
      : 'Patio sin iluminación encendida. Elige productos para encenderlos.');
  }

  /* ---------- armador ---------- */
  var chipsBox = q('[data-chips]');
  GROUPS.forEach(function (gr) {
    var keys = gr.keys.filter(function (k) { return P[k]; });
    if (!keys.length) return;
    var wrap = document.createElement('div'); wrap.className = 'sa-group';
    var lab = document.createElement('b'); lab.textContent = gr.name; wrap.appendChild(lab);
    var list = document.createElement('div'); list.className = 'sa-chips'; wrap.appendChild(list);
    keys.forEach(function (k) {
      var p = P[k];
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sa-chip-btn'; btn.setAttribute('aria-pressed', 'false'); btn.dataset.key = k;
      btn.innerHTML = (p.img ? '<img alt="" loading="lazy" width="48" height="48" src="' + p.img + '">' : '') +
        '<span class="t"><strong>' + SHORT[k] + '</strong><span>' + money(p.price) + '</span></span><span class="ck" aria-hidden="true"></span>';
      btn.addEventListener('click', function () { toggle(k); });
      list.appendChild(btn);
    });
    chipsBox.appendChild(wrap);
  });

  function toggle(k) {
    if (sel[k]) { delete sel[k]; hideMark(k); } else { sel[k] = 1; showMark(k); }
    if (night < 0.6 && Object.keys(sel).length && !reduce) animateTo(0.9, 1000);
    else if (night < 0.6) setNight(0.9);
    refresh();
  }

  var elTotal = q('[data-total]'), elWas = q('[data-was]'), elCount = q('[data-count]'),
      elBar = q('[data-ship]'), elMsg = q('[data-ship-msg]'), elTip = q('[data-tip]'),
      btnAdd = q('[data-add]'), elStatus = q('[data-status]');

  function compute() {
    var keys = Object.keys(sel), rest = {}, lines = [], regular = 0;
    keys.forEach(function (k) { rest[k] = 1; regular += P[k].price; });
    var cands = combos.map(function (c) {
      var sum = c.needs.reduce(function (a, k) { return a + P[k].price; }, 0);
      return { c: c, sum: sum, save: sum - c.price };
    }).filter(function (x) { return x.save > 0; }).sort(function (a, b) { return b.save - a.save; });
    cands.forEach(function (x) {
      if (x.c.needs.every(function (k) { return rest[k]; })) {
        x.c.needs.forEach(function (k) { delete rest[k]; });
        lines.push({ title: x.c.title, price: x.c.price, variant: x.c.variant, combo: x.c });
      }
    });
    Object.keys(rest).forEach(function (k) { lines.push({ title: P[k].title, price: P[k].price, variant: P[k].variant }); });
    var total = lines.reduce(function (a, l) { return a + l.price; }, 0);
    var tip = '';
    var applied = lines.filter(function (l) { return l.combo; });
    if (applied.length) {
      tip = '<strong>Combo aplicado:</strong> ' + applied.map(function (l) { return l.combo.short; }).join(' + ') + '. Ahorras ' + money(regular - total) + '.';
    } else {
      cands.some(function (x) {
        var missing = x.c.needs.filter(function (k) { return !sel[k]; });
        if (x.c.needs.length - missing.length >= 1 && missing.length === 1) {
          tip = 'Suma <strong>' + SHORT[missing[0]] + '</strong> y se arma el <strong>' + x.c.short + '</strong>: ahorras ' + money(x.save) + '.';
          return true;
        }
        return false;
      });
    }
    return { lines: lines, total: total, regular: regular, tip: tip };
  }

  var state = { lines: [] };
  function refresh() {
    qa('.sa-chip-btn').forEach(function (b) { b.setAttribute('aria-pressed', sel[b.dataset.key] ? 'true' : 'false'); });
    applyScene();
    var r = compute();
    var n = Object.keys(sel).length;
    elCount.textContent = n ? (n + (n === 1 ? ' producto en tu patio' : ' productos en tu patio')) : 'Tu patio está vacío';
    elTotal.textContent = money(r.total);
    elWas.textContent = r.regular > r.total ? money(r.regular) : '';
    elWas.hidden = !(r.regular > r.total);
    var th = data.threshold, pct = clamp(r.total / th, 0, 1) * 100;
    elBar.firstElementChild.style.width = pct + '%';
    elBar.classList.toggle('done', r.total >= th && n > 0);
    elMsg.textContent = n === 0 ? 'Envío gratis desde ' + money(th) + '.' :
      (r.total >= th ? '¡Tu pedido tiene envío gratis!' : 'Te faltan ' + money(th - r.total) + ' para el envío gratis.');
    elTip.innerHTML = r.tip; elTip.classList.toggle('show', !!r.tip);
    btnAdd.disabled = n === 0;
    btnAdd.textContent = n === 0 ? 'Elige al menos un producto' : 'Agregar al carrito · ' + money(r.total);
    state = r;
  }

  btnAdd.addEventListener('click', function () {
    if (!state.lines.length) return;
    var items = state.lines.map(function (l) { return { id: l.variant, quantity: 1 }; });
    if (data.mock) {
      elStatus.textContent = 'Prototipo: aquí se agregarían al carrito → ' + items.length + ' línea(s), total ' + money(state.total) + '.';
      return;
    }
    btnAdd.disabled = true; elStatus.textContent = 'Agregando…';
    fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function () { window.location.href = data.cartUrl; })
      .catch(function () { btnAdd.disabled = false; elStatus.textContent = 'No pudimos agregar algunos productos (puede que no haya stock). Inténtalo de nuevo o escríbenos por WhatsApp.'; });
  });
  q('[data-reset]').addEventListener('click', function () { sel = {}; refresh(); });

  /* ---------- control atardecer / noche ---------- */
  var slider = q('[data-night]');
  var anim = null;
  function cancelAnim() { if (anim) { cancelAnimationFrame(anim); anim = null; } }
  function animateTo(target, ms) {
    cancelAnim();
    var from = night, t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var k = clamp((ts - t0) / ms, 0, 1), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      setNight(from + (target - from) * e);
      if (k < 1) anim = requestAnimationFrame(step); else anim = null;
    }
    anim = requestAnimationFrame(step);
  }
  slider.addEventListener('input', function () { cancelAnim(); setNight(slider.value / 100, true); });

  /* ---------- arranque ---------- */
  if (P.pack3) sel.pack3 = 1;
  if (P.g10) sel.g10 = 1;
  setNight(0);
  refresh();
  function intro() {
    if (reduce) { setNight(0.9); return; }
    setTimeout(function () { if (!anim && night === 0) animateTo(0.9, 3800); }, 500);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); intro(); } }, { threshold: 0.35 });
    io.observe(photo);
  } else { intro(); }
})();
